import { render, staticRenderFns } from "./ProblemModal.vue?vue&type=template&id=3a7ac280&scoped=true"
import script from "./ProblemModal.vue?vue&type=script&lang=js"
export * from "./ProblemModal.vue?vue&type=script&lang=js"
import style0 from "./ProblemModal.vue?vue&type=style&index=0&id=3a7ac280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7ac280",
  null
  
)

export default component.exports